import { createContext, useContext } from 'react'

export const ChromeCompanionContext = createContext(null)

export const useChromeCompanionContext = () => useContext(ChromeCompanionContext)
